import React from 'react';

const TiktokOutlinedBlue = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
    >
        <path
            d="M12.425 3.422a4 4 0 0 1-.315-.183 4.4 4.4 0 0 1-.809-.688 3.8 3.8 0 0 1-.912-1.88h.004c-.07-.408-.04-.671-.037-.671H7.61v10.626q.002.213-.006.422 0 .026-.003.052l-.002.024v.006a2.33 2.33 0 0 1-1.174 1.852c-.346.197-.738.3-1.137.3a2.325 2.325 0 0 1-2.317-2.333 2.325 2.325 0 0 1 2.317-2.333c.243 0 .484.037.714.113l.003-2.798a5.1 5.1 0 0 0-3.933 1.15A5.4 5.4 0 0 0 .895 8.532c-.116.2-.554 1.004-.607 2.308-.033.74.189 1.507.295 1.824v.007c.067.187.325.824.746 1.36.34.431.74.81 1.19 1.124v-.007l.007.007c1.33.903 2.805.844 2.805.844.255-.01 1.11 0 2.082-.46 1.077-.51 1.69-1.27 1.69-1.27.392-.455.704-.973.922-1.532a5.7 5.7 0 0 0 .332-1.75V5.349c.033.02.477.314.477.314s.64.41 1.637.677c.716.19 1.681.23 1.681.23V3.842c-.338.037-1.024-.07-1.727-.42"
            fill="#009FDF"
        />
    </svg>
);
export default TiktokOutlinedBlue;
